export const canDiscardProduct = () => () => {
    return function (node) {
        const {bizNodeType, pkid, stsCode} = node.data

        if (! pkid) {
            this.logger.error('只有制品才能废弃', [node])
            return false
        }

        if ('RLS' !== stsCode) {
            this.logger.error('只有发布状态才能废弃', [node])
            return false
        }

        const bn = this.BizNode[bizNodeType]

        if (! bn.discard) {
            const name = bn.typeName(this, node.parent)
            this.logger.error(`${name}不支持废弃`, [node])
            return false
        }

        return (
            ! node.parent ||
            bn.isMounted(this, node)
        )
    }
}

export const discardProduct = () => () => {
    return function (nodes) {
        return Promise.allSettled(
            [...nodes].map(
                async node => {
                    try {
                        const _n = this.nodeProxy(node)
                        const updates = await _n.discard()
                        node.data = {...node.data, ...updates}
                        this.logger.info('废弃模型制品成功', [node])
                    }
                    catch (err) {
                        this.logger.error(
                            `废弃模型制品失败: ${err.message}`,
                            [node]
                        )

                        err.nodes = [node]
                        throw err
                    }
                }
            )
        )
    }
}
